export enum Permission {
  OrdersDelivery = 'orders_delivery.legacy_permission',
  OrdersPickup = 'orders_pickup.legacy_permission',
}
